// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.w-full{
    width: 100%;
}

.utility_bill_header{
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.utility_bill_header p{
    padding: 5px 10px;
    background-color: var(--bg);
    border: solid 1px black;
    border-radius: 5px;
}

.utility_bill_secion{
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: start;
    justify-content: center;
}


.utility_bill_userInformation{
    display: flex;
    flex-direction: row;
    width: -webkit-fill-available;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    border-radius: 10px;
    background-color: var(--bg-card);
    border: 1px solid var(--border);
    box-shadow: var(--shadow-sm);
}

.utility_bill_userInformation_profil{
    width: 50%;
    display: flex;
    gap: 15px;
    flex-direction: row;
    align-items: center;
}

.utility_bill_userInformation_profil_img {
    width: 80px;
    border-radius: 100%;
    height: 80px;
    background-position: center;
    background-size: cover;
}

.utility_bill_userInformation_infos{
    width: 50%;
}

.ocr_validation{
    display: flex;
    flex-direction: row;
    gap: 5px;
    align-items: center;
}

.ocr_confirmed{
    padding: 3px 8px;
    font-size: 12px;
    background-color: var(--success);
    color: white;
    border-radius: 4px;
}

.ocr_not_confirmed{
    padding: 3px 8px;
    font-size: 12px;
    margin-left: 5px;
    background-color: var(--danger);
    color: white;
    border-radius: 4px;
}

.utility_bill_pdf_container{
    justify-content: center !important;
    height: 80vh;
}

.utility_bill_embed_pdf{
    width: 100%;
    height: 100%;
}

.utility_bill_button_container{
    display: flex;
    flex-direction: row;
    gap: 10px;
    justify-content: end;
    width: 100%;
    align-items: center;
}

.utility_bill_button{
    padding: 10px 20px;
    border-radius: 8px;
}

.utility_bill_refused{
    padding: 10px 20px;
    border-radius: 8px;
    background-color: var(--danger);
    color: white;
    font-weight: bold;
}

.utility_bill_refused:disabled{
    background-color: rgb(164, 0, 0);
}

.utility_bill_accepted{
    padding: 10px 20px;
    border-radius: 8px;
    background-color: var(--success);
    color: white;
    font-weight: bold;
}

.utility_bill_refusal_reason{
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/pages/finances/subpages/UtilityBills/UtilityBill/utilityBill.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,2BAA2B;IAC3B,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,uBAAuB;AAC3B;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,gCAAgC;IAChC,+BAA+B;IAC/B,4BAA4B;AAChC;;AAEA;IACI,UAAU;IACV,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gCAAgC;IAChC,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,oBAAoB;IACpB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,+BAA+B;IAC/B,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gCAAgC;IAChC,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,mBAAmB;AACvB","sourcesContent":[".w-full{\n    width: 100%;\n}\n\n.utility_bill_header{\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.utility_bill_header p{\n    padding: 5px 10px;\n    background-color: var(--bg);\n    border: solid 1px black;\n    border-radius: 5px;\n}\n\n.utility_bill_secion{\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    align-items: start;\n    justify-content: center;\n}\n\n\n.utility_bill_userInformation{\n    display: flex;\n    flex-direction: row;\n    width: -webkit-fill-available;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px;\n    border-radius: 10px;\n    background-color: var(--bg-card);\n    border: 1px solid var(--border);\n    box-shadow: var(--shadow-sm);\n}\n\n.utility_bill_userInformation_profil{\n    width: 50%;\n    display: flex;\n    gap: 15px;\n    flex-direction: row;\n    align-items: center;\n}\n\n.utility_bill_userInformation_profil_img {\n    width: 80px;\n    border-radius: 100%;\n    height: 80px;\n    background-position: center;\n    background-size: cover;\n}\n\n.utility_bill_userInformation_infos{\n    width: 50%;\n}\n\n.ocr_validation{\n    display: flex;\n    flex-direction: row;\n    gap: 5px;\n    align-items: center;\n}\n\n.ocr_confirmed{\n    padding: 3px 8px;\n    font-size: 12px;\n    background-color: var(--success);\n    color: white;\n    border-radius: 4px;\n}\n\n.ocr_not_confirmed{\n    padding: 3px 8px;\n    font-size: 12px;\n    margin-left: 5px;\n    background-color: var(--danger);\n    color: white;\n    border-radius: 4px;\n}\n\n.utility_bill_pdf_container{\n    justify-content: center !important;\n    height: 80vh;\n}\n\n.utility_bill_embed_pdf{\n    width: 100%;\n    height: 100%;\n}\n\n.utility_bill_button_container{\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n    justify-content: end;\n    width: 100%;\n    align-items: center;\n}\n\n.utility_bill_button{\n    padding: 10px 20px;\n    border-radius: 8px;\n}\n\n.utility_bill_refused{\n    padding: 10px 20px;\n    border-radius: 8px;\n    background-color: var(--danger);\n    color: white;\n    font-weight: bold;\n}\n\n.utility_bill_refused:disabled{\n    background-color: rgb(164, 0, 0);\n}\n\n.utility_bill_accepted{\n    padding: 10px 20px;\n    border-radius: 8px;\n    background-color: var(--success);\n    color: white;\n    font-weight: bold;\n}\n\n.utility_bill_refusal_reason{\n    display: flex;\n    flex-direction: column;\n    align-content: center;\n    align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
